<template>
  <CModal
      :centered="true"
      :show.sync="editNewsModal"
      size="md"
      title="ویرایش خبر"
  >
    <CForm class="add-news-modal text-right">
      <CInput v-model="form.title" class="text-sm mt-3" label="تیتر خبر"/>
      <div class="d-flex align-items-center">
        <CSelect
            :options="computedAcl"
            :value.sync="form.acl"
            class="text-sm mt-3 flex-fill ml-1"
            label="قابل مشاهده"
        />
        <CSelect
            :options="computedTags"
            :value.sync="form.tagId"
            class="text-sm mt-3 flex-fill mr-1"
            label="تگ"
        />
      </div>
      <CTextarea v-model="form.text" class="text-sm mt-3" label="متن خبر"/>
      <div>
        <UploadBanner
            v-if="editNewsModal === true"
            v-model="form.bannerImageUrl"
            cat="NB"
            title="آپلود تصویر بنر"
            @upload-image="onUploadBannerImageUrl"
        />
        <UploadFile
            v-if="editNewsModal === true"
            v-model="form.fileUrls"
            cat="NF"
            title="آپلود فایل ها"
            @upload-file="onUploadFile"
        />

        <UploadMedia
            v-if="editNewsModal === true"
            v-model="form.mediaUrls"
            cat="NM"
            title="آپلود مدیا"
            @upload-media="onUploadMedia"
        />
      </div>
    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          class="px-5"
          color="primary"
          @click="onEditNews"
      >
        ارسال
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import UploadBanner from "../../UploadBanner/UploadBanner.vue";
import UploadMedia from "../../UploadMedia/UploadMedia.vue";
import UploadFile from "../../UploadFile/UploadFile.vue";

export default {
  components: {UploadBanner, UploadMedia, UploadFile},

  props: {
    value: {
      type: Boolean,
    },
    news: {
      type: Object,
    },
  },
  data() {
    return {
      tagList: [],
      aclList: [],
      form: {
        fileUrls: [],
        mediaUrls: [],
        bannerImageUrl: "",
      },
      loading: false,
    };
  },
  computed: {
    editNewsModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    computedTags() {
      return this.tagList.map((item) => {
        return {
          value: `${item.id}`,
          label: `${item.name}`,
        };
      });
    },
    computedAcl() {
      return this.aclList.map((item) => {
        return {
          value: `${item.value}`,
          label: `${item.title}`,
        };
      });
    },
  },

  watch: {
    editNewsModal(value) {
      if (value) {
        this.form = {
          title: this.news.title,
          text: this.news.text,
          fileUrls: this.news.fileUrls,
          bannerImageUrl: [this.news.bannerImageUrl],
          tagId: this.news.tag.id,
          acl: this.news.acl.toString(),
          mediaUrls: this.news.mediaUrls,
        };
      }
    }
  },
  beforeMount() {
    this.getTag();
    this.getAcl();
  },

  methods: {
    async getTag() {
      try {
        this.loading = true;
        const {data} = await axios.get("news/tag");
        this.tagList = data;
        this.tagList.unshift({id: "", name: ""});
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getAcl() {
      try {
        this.loading = true;
        const {data} = await axios.get("news/acl");
        this.aclList = data;
        this.aclList.unshift({value: "", title: ""});
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async onEditNews() {
      try {
        this.loading = true;
        const payload = {
          title: this.form.title,
          bannerImageUrl: this.form.bannerImageUrl[0].toString(),
          text: this.form.text,
          tagId: this.form.tagId,
          fileUrls: this.form.fileUrls,
          acl: this.form.acl,
          mediaUrls: this.form.mediaUrls,
        };
        await axios.put(`/news/${this.news.id}`, payload);
        this.form = {};
        this.$emit("get-news");
        this.editNewsModal = false;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onUploadFile(file) {
      this.form.fileUrls = [...new Set(this.form.fileUrls.concat(file))];
    },
    onUploadBannerImageUrl(image) {
      this.form.bannerImageUrl.unshift(image.toString());
    },
    onUploadMedia(media) {
      this.form.mediaUrls = [...new Set(this.form.mediaUrls.concat(media))];
    },
  },
};
</script>

<style lang="scss" scoped></style>